export default __webpack_public_path__ + "static/06.09-6059255dc2d8cd469ca716c73e3e628f.png";